<template>
  <Table ref="processCom" class="tableHead " stripe :columns="columns" :data="data">
  </Table>
</template>
<script>
export default {
  data () {
    return {
      columns: [
        {
          title: '进程',
          slot: 'name',
          align: 'center',
          tooltip: true,

        },
        {
          title: '文件',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        }, {
          title: '匹配子进程数',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        }, {
          title: '文件权限',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        }, {
          title: '操作系统',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        }, {
          title: '处理方式',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        }, {
          title: '状态',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        }, {
          title: '日志状态',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        }, {
          title: '备注',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        }, {
          title: '操作',
          key: 'ppid',
          align: 'center',
          tooltip: true,
          width: 200,
        },
      ],
      data: []
    }
  }
}
</script>
<style lang="scss" >
.tableHead {

  .ivu-table td,
  .ivu-table th {
    border: none;
  }
}
</style>